<div class="spacing-container">
  <div>
    <div class="info-text-container">
      <div>
        <span i18n="@@createRefundAmount.refundedValue"
          >Previously approved refunds:</span
        ><span>{{
          paymentRequest.refundedValue | value: localeService.getCurrentLocale()
        }}</span>
      </div>
      <div>
        <span i18n="@@createRefundAmount.refundableValue"
          >Left to refund:</span
        ><span>{{
          paymentRequest.refundableValue
            | value: localeService.getCurrentLocale()
        }}</span>
      </div>
    </div>
    <form [formGroup]="form">
      <label class="box-label">
        <div>
          <zaver-zfb-radio-button
            [selected]="form.controls.wholeAmount.value === 'true'"
            [color]="'cerise'"
          >
          </zaver-zfb-radio-button>
          <input
            style="display: none"
            type="radio"
            value="true"
            formControlName="wholeAmount"
          />
          <span i18n="@@createRefundAmount.wholeAmount">The whole amount</span>
        </div>
        <span>{{
          paymentRequest.refundableValue
            | value: localeService.getCurrentLocale()
        }}</span>
      </label>
      <label class="box-label">
        <div>
          <zaver-zfb-radio-button
            [selected]="form.controls.wholeAmount.value === 'false'"
            [color]="'cerise'"
          >
          </zaver-zfb-radio-button>
          <input
            style="display: none"
            type="radio"
            value="false"
            formControlName="wholeAmount"
          />
          <span i18n="@@createRefundAmount.partAmount">Part of the amount</span>
        </div>
      </label>
      <div class="amount" *ngIf="form.controls.wholeAmount.value === 'false'">
        <zaver-form-input
          [showContent]="true"
          placeholder="Amount"
          i18n-placeholder="@@createRefundAmount.form.amount.placeholder"
          [error]="form.controls.amount.invalid && showError"
          [errorMessage]="getAmountErrorMessage()"
          formControlName="amount"
          [inputMode]="'decimal'"
          [size]="'large'"
        >
          <span style="text-align: center; font-weight: 400; font-size: 14px">
            {{ paymentRequest.value.currencyCode }}
          </span>
        </zaver-form-input>
      </div>
      <div class="input-fields">
        <zaver-zfb-textarea
          title="Internal note"
          i18n-title="@@createRefundAmount.form.note.title"
          placeholder="Leave a note about the refund."
          i18n-placeholder="@@createRefundAmount.form.note.placeholder"
          formControlName="note"
          [error]="form.controls.note.invalid && showError"
          errorMessage="This field is required."
          i18n-errorMessage="@@createRefundAmount.form.note.errorMessage"
        >
        </zaver-zfb-textarea>
      </div>
    </form>
  </div>
  <div class="buttons-container">
    <zaver-primary-button
      text="Continue"
      i18n-text="@@createRefundAmount.button.forward"
      (click)="checkFormAndAdvance()"
    >
    </zaver-primary-button>

    <zaver-secondary-button-subtle
      text="Back"
      i18n-text="@@createRefundAmount.button.back"
      (click)="changeStep.emit('backwards')"
    >
    </zaver-secondary-button-subtle>
  </div>
</div>
